import { getDateTimeFormatter } from '../../../common/intlFormatters'

const AS_OF_OPTIONS: Intl.DateTimeFormatOptions = {
  month: '2-digit',
  day: '2-digit',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  timeZoneName: 'shortGeneric',
}

const formatAsOf = (moment: string, timeZone: string): string | undefined => {
  const at = new Date(moment)
  return Number.isNaN(at.getTime()) ? undefined : getDateTimeFormatter(AS_OF_OPTIONS, timeZone).format(at)
}

export const asOfText = (template: string | undefined, moment: string | undefined, timeZone: string): string | undefined => {
  if (!template || !moment) {
    return undefined
  }
  const asOf = formatAsOf(moment, timeZone)
  return asOf ? template.replace('{time}', asOf) : undefined
}
